import { SectionCard } from "@blueprintjs/core";
import { MISO_WHITEPAPER_URL } from "in_queue/constants";
import {
    CostAssumptionType,
    ScenarioMetadata
} from "in_queue/types/scenarioType";
import { getCostAssumptionText } from "in_queue/utils/scenarios";
import { ScenarioAssumptionsSection } from "../ScenarioAssumptions";
import css from "../ScenarioAssumptions.module.scss";

export const CostAssumptionsSection: React.FC<{
    scenario: ScenarioMetadata;
}> = ({ scenario }) => {
    const costAssumptions = scenario.costAssumptions;
    let description = null;
    if (costAssumptions.type === CostAssumptionType.NETWORK_UPGRADES) {
        description = (
            <>This scenario uses ISO-provided network upgrade costs.</>
        );
    } else if (costAssumptions.type === CostAssumptionType.CONSERVATIVE) {
        description = (
            <>
                This scenario uses conservative cost estimates. We assume a new
                single-circuit line build for every constraint.
            </>
        );
    } else if (costAssumptions.type === CostAssumptionType.SUGAR_UPGRADES) {
        description = (
            <>
                This scenario uses network upgrades determined using the process
                outlined in the{" "}
                <a href={MISO_WHITEPAPER_URL} target="_blank">
                    MISO Transmission Mitigation Selection and Cost Estimation
                    Approach Whitepaper
                </a>
                .
            </>
        );
    } else {
        description = (
            <>
                <p>This scenario uses custom cost estimates.</p>
                <p>
                    <b>Reconductor</b> assumed for constraints between 100% and{" "}
                    {costAssumptions.reconductorLoadingLimit}% loading.
                </p>
                <p>
                    <b>Rebuild</b> assumed for constraints between{" "}
                    {costAssumptions.reconductorLoadingLimit}% and{" "}
                    {costAssumptions.rebuildLoadingLimit}% loading.
                </p>
                <p>
                    <b>New single-circuit line build</b> assumed for constraints
                    above {costAssumptions.rebuildLoadingLimit}% loading.
                </p>
            </>
        );
    }
    return (
        <ScenarioAssumptionsSection
            section="costAssumptions"
            title={`Cost Assumptions - ${getCostAssumptionText(scenario)}`}
        >
            <SectionCard
                padded={false}
                className={css["scenario-assumptions-card"]}
            >
                {description}
            </SectionCard>
        </ScenarioAssumptionsSection>
    );
};
